import React from 'react';
import { TableCell, TableRow } from '@/components/ui/Table';
import I18n from '@/modules/i18n';
import BulkBarContent from '../BulkBarContent';
import { COLUMN_COUNT } from './columns';

interface BulkActionBarProps {
  count: number;
  disabled: boolean;
  onClear: () => void;
  onRemove: () => void;
}

const BulkActionBar = ({ count, disabled, onClear, onRemove }: BulkActionBarProps) => (
  <TableRow className="tw-border-b tw-border-solid tw-border-light-grey">
    <TableCell className="tw-px-4 tw-py-2" colSpan={COLUMN_COUNT}>
      <BulkBarContent
        actionLabel={I18n.t('remove_n_selected', { count })}
        color="red"
        count={count}
        disabled={disabled}
        onAction={onRemove}
        onClear={onClear}
      />
    </TableCell>
  </TableRow>
);

export default BulkActionBar;
